import { render, staticRenderFns } from "./form-tabs.vue?vue&type=template&id=56618fcd"
import script from "./form-tabs.vue?vue&type=script&lang=js"
export * from "./form-tabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports